import React from 'react';
import { ReactComponent as DownIcon } from 'components/icons/down.svg';
import { ReactComponent as BackIcon } from 'components/icons/back.svg';
import { IBreadcrumb } from 'interfaces/tagging/IBreadcrumb';
import { TaggingSteps } from 'enums/TaggingSteps';
import { Breadcrumb } from './Breadcrumb/Breadcrumb';
import { BackIconWrapper, BreadcrumbIcon, ExpandIconWrapper, SectionHeaderWrapper, Title } from './SectionHeaderStyles';

export interface IProps {
  title: string;
  hasBackIcon?: boolean;
  isExpandable?: boolean;
  onClickExpandIconCallback?: () => void;
  onClickBackIconCallback?: () => void;
  iconClassName?: string;
  isBreadcrumb?: boolean;
  breadcrumbs?: Array<IBreadcrumb>;
  onClickBreadcrumbCallback?: (value: TaggingSteps) => void;
  icon?: any;
}

export const SectionHeader: React.FC<IProps> = (props) => {
  const {
    title,
    isExpandable,
    onClickExpandIconCallback,
    iconClassName,
    isBreadcrumb,
    breadcrumbs,
    onClickBreadcrumbCallback,
    hasBackIcon,
    onClickBackIconCallback,
    icon,
  } = props;

  return (
    <SectionHeaderWrapper className={`${hasBackIcon ? 'back' : ''}`}>
      <BackIconWrapper>{hasBackIcon && <BackIcon onClick={() => onClickBackIconCallback && onClickBackIconCallback()} />}</BackIconWrapper>
      {isBreadcrumb &&
        breadcrumbs &&
        breadcrumbs.map((breadcrumb: IBreadcrumb, index) => {
          return (
            <Breadcrumb
              breadcrumb={breadcrumb.display}
              key={index}
              onClickCallback={() => onClickBreadcrumbCallback && onClickBreadcrumbCallback(breadcrumb.step)}
            />
          );
        })}
      {icon && <BreadcrumbIcon>{icon}</BreadcrumbIcon>}
      <Title className={hasBackIcon ? 'back-title' : ''}>{title}</Title>
      <ExpandIconWrapper>
        {isExpandable && <DownIcon className={iconClassName} onClick={() => onClickExpandIconCallback && onClickExpandIconCallback()} />}
      </ExpandIconWrapper>
    </SectionHeaderWrapper>
  );
};
